export default __webpack_public_path__ + "static/media/konnektive_logo.87040785.png";